import { render, staticRenderFns } from "./messages-settings-page.vue?vue&type=template&id=1f6739a1&"
import script from "./messages-settings-page.vue?vue&type=script&lang=js&"
export * from "./messages-settings-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports